import Component from './Component';

let thisComponent = null;

export default class videoGallery extends Component {

  load() {

    thisComponent = this;

    // console.log('videoGallery: ', thisComponent);

    super.load();
    // Reference to our iframe
    const iframe = document.querySelectorAll('.video-gallery-iframe');


    // Check if the scrollHandler is already defined, if not, define it
    if (!this.scrollHandler) {
      // lets only check the first iframe as we don't want multiple to autoplay.
      this.scrollHandler = () => this.checkAndPlay(iframe[0]);
    }

    // Add the scroll event listener
    window.addEventListener('scroll', this.scrollHandler);
  }

  // Function to check if the iframe is in the viewport
  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  checkAndPlay(iframe) {

    // Get the first video card from the list
    const firstVideoCard = document.querySelector('.video-card');
    const videoGallery = document.querySelector('.video-gallery-iframe');
    if (videoGallery.firstChild) {

      const image = document.createElement('image');

      image.src = firstVideoCard.getAttribute("data-video-image");
      const imageUrl = image?.src.trim().replace(/^['"]+|['"]+$/g, '');
      videoGallery.style.backgroundImage = `url(${imageUrl})`;
    }

    if (this.isInViewport(iframe)) {
      if (firstVideoCard) {
        // Extract the video link from the data attribute and play it
        const videoLink = firstVideoCard.getAttribute('data-video-link');
        this.playVideo(videoLink);

        if (this.scrollHandler && videoLink) {
          // Remove the event listener so the function doesn't keep firing
          window.removeEventListener('scroll', this.scrollHandler);
        }
      }
      this.initialiseVideoPlayback();
    }
  }

  initialiseVideoPlayback() {

    // Add event listeners to each video card for user-initiated play.
    const allVideoCards = document.querySelectorAll('.video-card');
    //const videoGallery = document.getElementById('video-gallery-iframe');
    allVideoCards.forEach(card => {

      card.addEventListener('click', function (event) {
        allVideoCards.forEach(innerCard => {
          innerCard.classList.remove('video-card-active');
        });

        const videoLink = card.getAttribute('data-video-link');
        card.classList.add('video-card-active');
        console.log('event: ', event);
        const relatedFrame = event.target.closest('.video-gallery').querySelector('.video-gallery-iframe');
        thisComponent.playVideo(videoLink, relatedFrame);
        //videoGallery.style.backgroundImage = 'none';
      });

    });
  }


  playVideo(videoLink, relatedFrame = document.querySelector('.video-gallery-iframe')) {

    const iframe = document.createElement('iframe');
    let videoId = this.extractVideoID(videoLink);
    console.log("playVideo", videoLink, videoId);
    if (thisComponent.isValidYouTubeLink(videoLink)) {
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&muted=1&rel=0`;
      iframe.setAttribute("allow", "autoplay");
    } else if (videoLink.includes('vimeo.com')) {
      iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1`; //if the muted attribute is removed, the video will not auto play.
    }

    //iframe.loading = 'lazy';
    iframe.setAttribute('style', 'width: 100%; height: 100%; border: none;');

    const videoGallery = relatedFrame; // play in the related frame

    if (videoGallery.firstChild) {
      videoGallery.replaceChild(iframe, videoGallery.firstChild);
    } else {
      videoGallery.appendChild(iframe);
    }

  }

  extractVideoID(videoLink) {

    if (this.isValidYouTubeLink(videoLink)) {
      return this.extractYouTubeID(videoLink);
    } else if (videoLink.includes('vimeo.com')) {
      return videoLink.split('/').pop();
    }
    return '';
  }

  isValidYouTubeLink(url) {
    const regex = /^(https:\/\/www\.youtube\.com\/watch\?v=[^?&]+|https:\/\/youtu\.be\/[^?&]+(?:\?si=[^?&]+)?|https:\/\/www\.youtube\.com\/embed\/[^?&]+(?:\?si=[^?&]+)?)$/;
    return regex.test(url);
  }

  extractYouTubeID = (url) => {
    const regex = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^?&]+)/;
    const match = url.match(regex);

    return match ? match[1] : null;
  }

}
